import script from "./weekTable.vue?vue&type=script&setup=true&lang=js"
export * from "./weekTable.vue?vue&type=script&setup=true&lang=js"

import "./weekTable.vue?vue&type=style&index=0&id=3bb25a95&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb25a95"]])

export default __exports__